import { ComponentMultiStyleConfig } from '@chakra-ui/react';

const ResponsiveLayoutTheme: ComponentMultiStyleConfig = {
  parts: [
    'responsiveLayoutMainContent',
    'responsiveTwoColumnLayout',
    'responsiveLayoutLeftContent',
    'responsiveLayoutRightContent'
  ],
  baseStyle: {
    responsiveLayout: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    },
    responsiveLayoutMainContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '40px',
      margin: '0 auto',
      minWidth: '0',
      overflowY: 'auto',
      backgroundColor: 'silver.lighter',
      '> div': {
        width: '100%',
        maxWidth: '1080px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    },
    responsiveTwoColumnLayout: {
      display: 'flex',
      width: '100%',
      marginTop: '32px',
      flexWrap: 'wrap',
      '@media (min-width: 1150px)': { flexWrap: 'nowrap' },
      gap: '32px'
    },
    responsiveLayoutLeftContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      flexGrow: '1',
      minWidth: '100%',
      '@media (min-width: 1150px)': { minWidth: '0' }
    },
    responsiveLayoutRightContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      flexBasis: '100%',
      flexGrow: '1',
      minWidth: '100%',
      '@media (min-width: 1150px)': {
        flexBasis: '336px',
        flexGrow: '0',
        minWidth: '0'
      }
    }
  },
  defaultProps: {}
};

export default ResponsiveLayoutTheme;
